export default {"src":"/_next/static/media/Telegram.2efe6db8.svg","height":50,"width":50,"blurWidth":0,"blurHeight":0};